import type { ExternalAppRow } from './external-app-actions'

export const connections = (row: ExternalAppRow): ExternalAppRow[] => row.subRows ?? []

// Ignores blanks: `buildGroupedTableRows` blanks `created_on` on the group row itself.
export const rollUpConnectedOn = (row: ExternalAppRow): string | null => {
  const dates = connections(row)
    .map((connection) => connection.created_on)
    .filter((date): date is string => Boolean(date))
  if (dates.length === 0) return null
  return dates.reduce((latest, date) => (date > latest ? date : latest))
}
